export default __webpack_public_path__ + "static/media/virtual-bg11.4f65e318.png";